export default "__VITE_ASSET__CrdkIsTb__"